import React, {useEffect, useState} from 'react';
import {
    ProviderEventListFilterValue,
    ProviderEventTypeNameMap,
    ProviderEventTypeNames,
    ProviderViewOnlyOptionMapWithDefault
} from "./domain";
import {DropdownMultiSelect, MultiFilterButton, SimpleDropdown} from "common";
import {ProviderEventListAction} from "./providerEventListReducer";
import DatePicker from "react-datepicker";
import {DatePickerInput} from "../../common/component/DatePickerInput";
import {ProviderPersonLookupMultipleInput} from "./ProviderPersonLookupMultipleInput";
import {ProviderPortalFeatureFlag, useFeatureFlag} from "featureflag";


type Props = {
    initFilterValue: ProviderEventListFilterValue,
    dispatch: React.Dispatch<ProviderEventListAction>
}

export const IsFilterEmpty = (filter: ProviderEventListFilterValue) => {
    return filter.viewedOnly === "" && filter.eventTypes === "" && filter.eventSince === null;
}

export function ProviderEventListFilter({initFilterValue, dispatch}: Props) {
    const [filterValue, setFilterValue] = useState({...initFilterValue});
    const hideProgressPortrait = useFeatureFlag(ProviderPortalFeatureFlag.BHPNPP_3219_PROGRESS_PORTRAIT_DISABLED);
    // update internal value when init filter value updated
    useEffect(() => {
        setFilterValue(initFilterValue);
    }, [initFilterValue])

    const onFilterUpdate = (fieldName: string, fieldValue: any) => {
        setFilterValue({...filterValue, [fieldName]: fieldValue})
    }

    return <MultiFilterButton<ProviderEventListFilterValue>
        filterValue={filterValue}
        setFilterValue={setFilterValue}
        dispatchSetFilterValue={(val) => dispatch({type: "SET_FILTER", filter: val})}
        filterOptions={[
            {
                label: "Notification Type",
                component:
                    <DropdownMultiSelect
                        placeholder={'— — Choose Types — —'}
                        field={'eventTypes'}
                        options={ProviderEventTypeNames}
                        hideFunc={(option) => hideProgressPortrait && option === 'Progress_Portrait_Sync'}
                        value={filterValue.eventTypes}
                        full
                        labelMapperFunc={(val) => ProviderEventTypeNameMap.get(val)!!}
                        setValue={(val) => setFilterValue({...filterValue, eventTypes: val})}
                    />

            },

            {
                label: "Client",
                component: <ProviderPersonLookupMultipleInput
                    personLookupType={"Client"}
                    fieldValues={filterValue.clients}
                    setFieldValues={(values) => onFilterUpdate("clients", values)}
                />
            },
            {
                label: "Status",
                component:
                    <SimpleDropdown
                        options={ProviderViewOnlyOptionMapWithDefault}
                        selected={filterValue.viewedOnly}
                        minWidth={"7rem"}
                        textColor={"gray-600"}
                        setSelected={(val) => onFilterUpdate("viewedOnly", val)}/>

            },
            {
                label: "Notification Since",
                subLabel: "Note: Unread messages count calculated from last 30 days",
                component:
                    <DatePicker
                        wrapperClassName="w-full"
                        selected={filterValue.eventSince || null}
                        onSelect={(newValue: Date | null) => onFilterUpdate("eventSince", newValue)}
                        onChange={() => {}}
                        customInput={<DatePickerInput
                            fieldName="eventSince"
                            value={undefined}
                            onFinish={(newValue: Date | null) => onFilterUpdate("eventSince", newValue)}
                        />}
                    />
            },
            {
                label: "Report Submitted By",
                component: <ProviderPersonLookupMultipleInput
                    includeCurrentUser={true}
                    personLookupType={"ProviderUser"}
                    fieldValues={filterValue.reportSubmittedBy}
                    setFieldValues={(values) => onFilterUpdate("reportSubmittedBy", values)}
                />
            },
        ]}
        emptyFilterValue={{
            eventSince: null,
            eventTypes: "",
            viewedOnly: "",
            clients: [],
            reportSubmittedBy: []
        }}
    />;
}
